// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideSparkle as RawLucideSparkle } from "lucide-react";
export const LucideSparkle = /* @__PURE__ */ createIcon(RawLucideSparkle, "LucideSparkle", 2);
